import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { fetchMyhouses, fetchHouse, updateRouteHouseNo, updateCurrentHouseNo, updateRelocationGrid } from '@Root/slices/myhouse/mainSlice'
import { RootState } from '@Root/slices'
import MyhouseMainHouseResponse from '@Root/types/entities/MyhouseMainHouseResponse'

export default function useMain() {
  const dispatch = useDispatch()
  const reduxMain = useSelector((state: RootState) => state.main)
  const { houseList } = reduxMain

  const loadMainHouses = useCallback(() => {
    dispatch(fetchMyhouses())
  }, [dispatch])

  const loadHouse = useCallback(
    (houseNo: number) => {
      if (houseNo >= 0) {
        const complexNo = ((houseList as MyhouseMainHouseResponse[]).find((h) => h.houseNo === houseNo) as MyhouseMainHouseResponse)?.complexNo
        dispatch(fetchHouse({ houseNo, complexNo }))
      }
    },
    [dispatch, houseList],
  )

  const setRouteHouseNo = useCallback(
    (routeHouseNo: number) => {
      dispatch(updateRouteHouseNo(routeHouseNo))
    },
    [dispatch],
  )

  const setCurrentHouseNo = useCallback(
    (param: { currentHouseNo: number }) => {
      dispatch(updateCurrentHouseNo(param))
    },
    [dispatch],
  )

  /**
   * @remarks
   * Calling this method with the "MyhouseMainMasonryLayout" subcomponent render lifecycle puts the redux dispatch into an infinite loop.
   */
  const refreshMasonryGrid = useCallback(() => {
    dispatch(updateRelocationGrid(true))
  }, [dispatch])

  const setRelocationGrid = useCallback(
    (value: boolean) => {
      dispatch(updateRelocationGrid(value))
    },
    [dispatch],
  )

  return {
    loadMainHouses,
    loadHouse,
    reduxMain,
    setRouteHouseNo,
    setCurrentHouseNo,
    refreshMasonryGrid,
    setRelocationGrid,
  }
}
